import { Type, type Static } from "@sinclair/typebox";
import { Cents } from "./domain.ts";

/** A Pix charge to pay: copia-e-cola + QR image (trips, tips, debts). */
export const PixPayment = Type.Object(
  { qrCode: Type.String(), qrCodeBase64: Type.String(), expiresAt: Type.String({ format: "date-time" }), amountCents: Cents },
  { $id: "PixPayment" },
);

/**
 * Pagar na hora (docs/specs/cash-payments.md): a completed cash trip's collection. `open` until the
 * driver settles it: `cash` (received in hand), `pix` (the Pix on their phone was paid) or `unpaid`
 * (the rider got a debt; the driver is paid anyway). `pix` is the charge to show while one is pending.
 */
export const CollectionStatus = Type.Union([Type.Literal("open"), Type.Literal("cash"), Type.Literal("pix"), Type.Literal("unpaid")], { $id: "CollectionStatus" });
export const TripCollectionView = Type.Object(
  { tripId: Type.String(), status: CollectionStatus, amountCents: Cents, pix: Type.Union([PixPayment, Type.Null()]) },
  { $id: "TripCollectionView" },
);
export type TripCollectionView = Static<typeof TripCollectionView>;

/** `POST /driver/trips/{id}/collect`. */
export const CollectInput = Type.Object(
  { method: Type.Union([Type.Literal("cash"), Type.Literal("pix"), Type.Literal("unpaid")]) },
  { $id: "CollectInput" },
);
export type CollectInput = Static<typeof CollectInput>;

/** `POST /driver/balance/settle` ("Quitar saldo"): a Pix for the whole negative repasse balance. */
export const DriverBalanceSettlement = Type.Object({ balanceCents: Type.Integer(), pix: PixPayment }, { $id: "DriverBalanceSettlement" });
export type DriverBalanceSettlement = Static<typeof DriverBalanceSettlement>;
